import { FetchError } from "@selector/shared";
import type { FallbackProps } from "react-error-boundary";
import {
  ActionButton,
  ActionButtonIntent,
  Icons,
  PanelOrientation,
  PanelPosition,
  ResizableTabPanels,
  Spacer,
  VStack,
} from "widgets";

import { InspectionPanelTabs, StatusPanelTabs } from "../../types.ts";
import { ShortcutsCard } from "../help/Shortcuts.tsx";
import { GenomeViewerStatusBarActions } from "../toolbar/GenomeViewerStatusBarActions.tsx";
import { GenomeViewerToolbarContainer, ToggleInspectionPanel } from "../toolbar/GenomeViewerToolbar.tsx";
import { BadRequestPage } from "./bad-request-page.tsx";
import { ErrorPage } from "./error-page.tsx";
import { NotFoundPage } from "./not-found-page.tsx";

export const ErrorFallbackPage = ({ resetErrorBoundary, error }: FallbackProps) => {
  return (
    <ResizableTabPanels
      orientation={PanelOrientation.Horizontal}
      fixedPanel={PanelPosition.Trailing}
      defaultSize={350}
      minSize={240}
      maxSize={480}
      isContinuous
      style={{ width: "100%", height: "100%" }}
    >
      <ResizableTabPanels.FlexPanel>
        <VStack spacing={0} style={{ width: "100%", height: "100%" }}>
          <GenomeViewerToolbarContainer>
            <Spacer />
            <ToggleInspectionPanel />
          </GenomeViewerToolbarContainer>
          <ResizableTabPanels
            orientation={PanelOrientation.Vertical}
            fixedPanel={PanelPosition.Trailing}
            minSize={250}
            defaultSize={250}
            closedSize={39}
            isContinuous
            openOnTabPress
            tabsActions={[<GenomeViewerStatusBarActions key="status-bar-toggle" />]}
            defaultOpen={false}
            style={{ width: "100%", height: "100%" }}
          >
            <ResizableTabPanels.FlexPanel>
              <VStack spacing={10} style={{ justifyContent: "center", alignItems: "center", margin: "auto" }}>
                {!(error instanceof FetchError) ? (
                  <ErrorPage message={error.message} />
                ) : error.statusCode === 400 ? (
                  <BadRequestPage message={error.message} />
                ) : error.statusCode === 404 ? (
                  <NotFoundPage message={error.message} />
                ) : (
                  <ErrorPage message={error.message} />
                )}
                <ActionButton
                  onPress={() => {
                    resetErrorBoundary();
                  }}
                  label="Reset"
                  icon="restart_alt"
                  intent={ActionButtonIntent.Danger}
                />
              </VStack>
            </ResizableTabPanels.FlexPanel>
            <ResizableTabPanels.FixedPanel>
              <ResizableTabPanels.FixedPanelTab
                id={StatusPanelTabs.Help}
                title={StatusPanelTabs.Help}
                position={0}
                icon="keyboard"
              >
                <ShortcutsCard />
              </ResizableTabPanels.FixedPanelTab>
            </ResizableTabPanels.FixedPanel>
          </ResizableTabPanels>
        </VStack>
      </ResizableTabPanels.FlexPanel>
      <ResizableTabPanels.FixedPanel>
        <ResizableTabPanels.FixedPanelTab
          icon={<img src={Icons.Action.GenomeViewer} width={20} height={20} alt="" />}
          title="Synteny"
          position={0}
          id={InspectionPanelTabs.GenomeViewer}
        >
          <div />
        </ResizableTabPanels.FixedPanelTab>
        <ResizableTabPanels.FixedPanelTab icon="search" title="Search" position={1} id={InspectionPanelTabs.Search}>
          <div />
        </ResizableTabPanels.FixedPanelTab>
      </ResizableTabPanels.FixedPanel>
    </ResizableTabPanels>
  );
};
